import { render } from "./Renovacion04Completo.vue?vue&type=template&id=580865ac"
import script from "./Renovacion04Completo.vue?vue&type=script&lang=js"
export * from "./Renovacion04Completo.vue?vue&type=script&lang=js"

import "./Renovacion04Completo.vue?vue&type=style&index=0&id=580865ac&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__